/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { ReactNode } from "react";
import ContentBoxHead from "./ContentBoxHead";
import Grid from "@mui/material/Grid";
import contentBoxStyle from "./contentBoxStyle";
import Paper from "@mui/material/Paper";
import { BoxHeadingLoader } from "../../ContentLoader/BoxHeadingLoader";

type ContentBoxProps = {
  icon?: any;
  headline: string;
  children: ReactNode;
  elevation?: number;
  alignContent?: string;
  loading?: boolean;
};

const ContentBox = ({ icon, headline, children, elevation = 4, alignContent = "stretch", loading = false }: ContentBoxProps) => {
  return (
    <Paper elevation={elevation} sx={contentBoxStyle.paper}>
      <Grid container sx={contentBoxStyle.container} alignContent={alignContent} justifyContent={"center"}>
        <Grid item>
          {!loading && <ContentBoxHead Icon={icon} headline={headline} />}
          {loading && <BoxHeadingLoader />}
        </Grid>
        <Grid item xs={12} sx={contentBoxStyle.content}>
          {children}
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ContentBox;
